import React from 'react';

export enum ArticlePreviewSideEnum {
  LEFT = 'left',
  RIGHT = 'right',
}

export type ArticlePreviewInterface = React.PropsWithChildren<{
  className?: string;
  imageSide?: ArticlePreviewSideEnum;
  imageUrl: string;
}> & React.HTMLAttributes<HTMLDivElement>;
